export const api = {
  GET_NFTS: '/getNfts',
  GET_NFT_METADATA: '/getNFTMetadata',
  GET_OWNED_NFTS: '/users/wallet/nfts',
}
